import React from "react";
import ContentHeader from "components/content/header";
import { useTranslation } from "react-i18next";

const Summary = (props) => {
	const { t } = useTranslation();

	return (
		<>
			<section className="section-padding" id="summary-section">
				<div className="container">
					<div className="row">
						<div className="col-12">
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Summary;